import { render, staticRenderFns } from "./admin-doctor-select.vue?vue&type=template&id=5a792338&"
import script from "./admin-doctor-select.vue?vue&type=script&lang=js&"
export * from "./admin-doctor-select.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports